import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgErrorBooting({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={180}
      height={116}
      viewBox="0 0 180 116"
      fill="none"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M93.236 115c29.823 0 54-23.953 54-53.5S123.059 8 93.236 8s-54 23.953-54 53.5 24.177 53.5 54 53.5z"
        fill="#FAC5C5"
      />
      <path
        d="M86.236 110c29.547 0 53.5-23.729 53.5-53s-23.953-53-53.5-53-53.5 23.729-53.5 53 23.953 53 53.5 53z"
        stroke="#000"
      />
      <path
        d="M99.733 20.792c-19.98-7.273-41.997 2.82-49.175 22.54-7.178 19.721 3.2 41.604 23.181 48.876 19.98 7.273 41.997-2.82 49.175-22.54a37.474 37.474 0 002.274-12.94 37.806 37.806 0 00-1.91-11.747M117.359 36.193a37.292 37.292 0 00-2.923-3.807 37.798 37.798 0 00-4.654-4.477"
        stroke="#000"
        strokeLinecap="round"
      />
      <path stroke="#000" d="M67.354 37.647l40 40M66.646 77.646l40-40" />
    </svg>
  );
}
export default SvgErrorBooting;
